module.exports = __webpack_public_path__ + "static/media/irp.67a698a6.svg";